export default __webpack_public_path__ + "static/media/01.f0379ceb.jpg";